/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 6217:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// UNUSED EXPORTS: TTNFooter

// EXTERNAL MODULE: ./node_modules/lit-element/lit-element.js + 5 modules
var lit_element = __webpack_require__(2148);
;// CONCATENATED MODULE: ./ui/src/components/ttn-footer/mailchimp-signup.js

/* harmony default export */ const mailchimp_signup = (lit_element/* html */.dy` <!-- Begin Mailchimp Signup Form -->
  <div id="mc_embed_signup">
    <form
      action="https://thethingsindustries.us17.list-manage.com/subscribe/post?u=a6a1844f352b77f25c73c98fd&amp;id=3257aee67f"
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      class="validate"
      target="_blank"
      novalidate
    >
      <div id="mc_embed_signup_scroll">
        <label for="mce-EMAIL">Subscribe to our newsletter</label>
        <div class="column">
          <input
            type="email"
            value=""
            name="EMAIL"
            class="email"
            id="mce-EMAIL"
            placeholder="Email"
            required
          />
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input
              type="text"
              name="b_a6a1844f352b77f25c73c98fd_3257aee67f"
              tabindex="-1"
              value=""
            />
          </div>
          <div class="clear">
            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              class="button"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--End mc_embed_signup-->`);
// EXTERNAL MODULE: ./ui/src/components/ttn-footer/ttn-footer.styl
var ttn_footer = __webpack_require__(9765);
;// CONCATENATED MODULE: ./ui/src/components/ttn-footer/index.js



class TTNFooter extends lit_element/* LitElement */.oi {
  static get styles() {
    return (0,lit_element/* unsafeCSS */.$m)(ttn_footer/* default.toString */.Z.toString());
  }
  static get properties() {
    return {
      rootUrl: {
        type: String,
        attribute: 'root-url'
      }
    };
  }
  constructor() {
    super();
    this.rootUrl = 'https://www.thethingsnetwork.org';
  }
  render() {
    return lit_element/* html */.dy`
      <ttui-footer
        privacy-policy-url="https://id.thethingsnetwork.org/legal/privacy-policy"
        terms-url="https://id.thethingsnetwork.org/legal/terms-of-service"
        sponsor-text="Sponsored By"
      >
        <ttui-footer-nav slot="menu" title="Features">
          <ttui-footer-nav-item>
            <a href="${this.rootUrl}/learn">Learn</a>
          </ttui-footer-nav-item>
          <ttui-footer-nav-item>
            <a href="${this.rootUrl}/device-repository">Hardware</a>
          </ttui-footer-nav-item>
        </ttui-footer-nav>

        <ttui-footer-nav slot="menu" title="Resources">
          <ttui-footer-nav-item>
            <a href="${this.rootUrl}/community">Communities</a>
          </ttui-footer-nav-item>
        </ttui-footer-nav>

        <ttui-footer-nav slot="menu" title="More from us">
          <ttui-footer-nav-item>
            <a href="https://www.thethingsconference.com">Conference</a>
          </ttui-footer-nav-item>
          <ttui-footer-nav-item>
            <a href="https://www.thethingsindustries.com">Enterprise</a>
          </ttui-footer-nav-item>
        </ttui-footer-nav>

        <ttui-footer-nav slot="menu" title="Legal" mobile-only>
          <ttui-footer-nav-item>
            <a href="https://id.thethingsnetwork.org/legal/privacy-policy">Privacy policy</a>
          </ttui-footer-nav-item>
          <ttui-footer-nav-item>
            <a href="https://id.thethingsnetwork.org/legal/terms-of-service">Terms of use</a>
          </ttui-footer-nav-item>
        </ttui-footer-nav>

        <ttui-footer-social slot="social">
          <ttui-footer-social-icon
            platform="youtube"
            url="https://www.youtube.com/c/TheThingsNetworkCommunity"
            align-left
          ></ttui-footer-social-icon>
          <ttui-footer-social-icon
            platform="github"
            url="https://github.com/TheThingsNetwork/lorawan-stack"
            align-left
          ></ttui-footer-social-icon>
          <ttui-footer-social-icon
            platform="twitter"
            url="https://twitter.com/thethingsntwrk"
            align-left
          ></ttui-footer-social-icon>
          <ttui-footer-social-icon
            platform="facebook"
            url="https://www.facebook.com/thethingsnetwork"
            align-left
          ></ttui-footer-social-icon>
          <ttui-footer-social-icon
            platform="linkedin"
            url="https://www.linkedin.com/company/the-things-network/"
            align-left
          ></ttui-footer-social-icon>
        </ttui-footer-social>
        <div slot="cta">
          <section class="signup">${mailchimp_signup}</section>
        </div>
      </ttui-footer>
    `;
  }
}
window.customElements.define('ttn-footer', TTNFooter);

/***/ }),

/***/ 9765:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_node_modules_normalize_css_normalize_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5735);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_node_modules_suitcss_base_lib_base_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4212);
// Imports



var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_node_modules_normalize_css_normalize_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_node_modules_suitcss_base_lib_base_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{padding:0;line-height:inherit;color:inherit}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}html:not(.ttui-disable-typography){font-size:16px;height:100%;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol';line-height:var(--lh-m)}@media screen and (max-width:620px){html:not(.ttui-disable-typography){font-size:14px}}html:not(.ttui-disable-typography):not(.ttui-disable-font-smoothing){-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}h1,h2,h3,h4,h5{font-family:'ITC Avant Garde Pro',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}h1{font-size:var(--fs-xl3);line-height:var(--lh-xs)}h2{font-size:var(--fs-xxl);line-height:var(--lh-xs)}h3{font-size:var(--fs-l);line-height:var(--lh-s)}h4{font-size:var(--fs-m);line-height:var(--lh-s)}h5{font-size:var(--fs-s);line-height:var(--lh-m)}.column{display:-webkit-box;display:-moz-box;display:-webkit-flex;display:-ms-flexbox;display:box;display:flex;-webkit-box-orient:vertical;-moz-box-orient:vertical;-o-box-orient:vertical;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}#mc_embed_signup_scroll{display:-webkit-box;display:-moz-box;display:-webkit-flex;display:-ms-flexbox;display:box;display:flex;-webkit-box-orient:vertical;-moz-box-orient:vertical;-o-box-orient:vertical;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}#mc_embed_signup_scroll label{font-weight:var(--fw-bolder);color:var(--c-text-03);width:100%;margin-bottom:var(--cs-m);font-size:var(--fs-s)}#mc_embed_signup_scroll .email{border:solid .5px var(--c-line-03);border-radius:var(--br-s);min-width:var(--ls-l);padding:var(--cs-s) var(--cs-m);color:var(--c-text-03);-webkit-box-flex:1;-moz-box-flex:1;-o-box-flex:1;-ms-box-flex:1;box-flex:1;-webkit-flex-grow:1;flex-grow:1;margin-bottom:var(--cs-s)}#mc_embed_signup_scroll .clear{min-width:var(--ls-m);-webkit-box-flex:1;-moz-box-flex:1;-o-box-flex:1;-ms-box-flex:1;box-flex:1;-webkit-flex-grow:1;flex-grow:1}::placeholder{color:var(--c-text-05)}#mc-embedded-subscribe{width:100%;height:100%;border-radius:var(--br-s);padding:var(--cs-s);-webkit-appearance:none;outline:0;border:0;background-color:var(--c-interactive-03);color:var(--c-background-04);cursor:pointer}#mc-embedded-subscribe:hover{background-color:var(--c-interactive-02);-webkit-transition:color 0.2s;-moz-transition:color 0.2s;-o-transition:color 0.2s;-ms-transition:color 0.2s;transition:color 0.2s}", ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	(() => {
/******/ 		__webpack_require__.j = 18;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			18: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk_tti_design"] = self["webpackChunk_tti_design"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [253], () => (__webpack_require__(6217)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;